namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.OfferRedemptionDialog')
    export class OfferRedemptionDialog extends Serenity.EntityDialog<OfferRedemptionRow, any> {
        protected getFormKey() { return OfferRedemptionForm.formKey; }
        protected getIdProperty() { return OfferRedemptionRow.idProperty; }
        protected getLocalTextPrefix() { return OfferRedemptionRow.localTextPrefix; }
        protected getNameProperty() { return OfferRedemptionRow.nameProperty; }
        protected getService() { return OfferRedemptionService.baseUrl; }
        protected getDeletePermission() { return OfferRedemptionRow.deletePermission; }
        protected getInsertPermission() { return OfferRedemptionRow.insertPermission; }
        protected getUpdatePermission() { return OfferRedemptionRow.updatePermission; }

        protected form = new OfferRedemptionForm(this.idPrefix);
    }
}